import React from 'react';
import {Modal, Text} from '@forecast-it/design-system';
import {FormattedMessage} from 'react-intl';
import {hasPermission} from '../../../../../forecast-app/shared/util/PermissionsUtil';
import {PERMISSION_TYPE} from '../../../../../Permissions';
import {useHistory} from 'react-router-dom';

type MissingClientBillToWarningModalProps = {
	clientId: string;
	fromProjectSettings?: boolean;
	closeModal: () => void;
};

const MissingClientBillToWarningModal = ({
	closeModal,
	clientId,
	fromProjectSettings,
}: MissingClientBillToWarningModalProps): JSX.Element => {
	const isAdmin = hasPermission(PERMISSION_TYPE.MANAGE_ACCOUNT_SETTINGS);
	const history = useHistory();

	const goToClientPage = () => {
		closeModal();
		history.push(`/admin/clients/view-client/${clientId}`);
	};

	return (
		<Modal onCloseModal={closeModal}>
			<Modal.Title>
				<FormattedMessage
					id={
						fromProjectSettings
							? 'invoicing.project.client_bill_tos_missing.title'
							: 'invoicing.add_billing_details_and_export_invoice'
					}
				/>
			</Modal.Title>
			<Modal.Content>
				<Text>
					<FormattedMessage
						id={
							fromProjectSettings
								? 'invoicing.project.client_bill_tos_missing.description'
								: 'invoicing.client_bill_tos_missing'
						}
					/>
				</Text>
				<Text>
					<FormattedMessage
						id={
							isAdmin
								? 'invoicing.client_bill_tos_missing_add_from_client_page'
								: 'invoicing.client_bill_tos_missing_contact_admin'
						}
					/>
				</Text>
			</Modal.Content>
			<Modal.Footer>
				{isAdmin && (
					<Modal.PrimaryFooterButton onPress={goToClientPage}>
						<FormattedMessage id={'invoicing.go_to_client_page'} />
					</Modal.PrimaryFooterButton>
				)}
				<Modal.SecondaryFooterButton onPress={closeModal}>
					<FormattedMessage id={'common.cancel'} />
				</Modal.SecondaryFooterButton>
			</Modal.Footer>
		</Modal>
	);
};

export default MissingClientBillToWarningModal;
